import React from 'react'
import { Button } from 'react-bootstrap'
import { BadgeX  } from 'lucide-react'

export default function CrossButton(props) {

    const { onClick, disabled } = props

    return (
        <>
            <Button
                type='button'
                variant='light'
                size='sm'
                onClick={onClick}
                disabled={disabled}
            >
                <BadgeX size={16} style={{ marginBottom: '2px' }} className='text-danger' />
            </Button>
        </>
    )
}